/* eslint-disable react/jsx-no-comment-textnodes */

import React from "react";
import styled, { css } from "styled-components";
import { Col } from "react-bootstrap";

import {
  Block,
  Footer,
  Nav,
  PhoneMenu,
  SidesKnaifel,
  Spacer,
  Text,
  Title,
} from "../../../lib";
import { mediaQuery } from "../../../utils";

const PageTitle = styled(Text)`
  font-size: 80px;
  margin-bottom: 100px;
  margin-right: 7vw;
  text-align: right;

  ${mediaQuery(
    "phone",
    css`
      display: none;
    `,
  )}
`;

const Root = styled.div`
  ${mediaQuery(
    "phone",
    css`
      margin-top: 120px;
    `,
  )}
`;

const StyledPhoneMenu = styled(PhoneMenu)`
  margin-top: -50px;
`;

const Source: React.FC = () => (
  <Root>
    <Nav />
    <StyledPhoneMenu />
    <PageTitle>александр кнайфель (3)</PageTitle>

    <SidesKnaifel hideRight="source">
      <Col
        lg={{ offset: 1, span: 10 }}
        style={{ transform: "translateX(20px)" }}
      >
        <Spacer size={10} />
        <Title size={72}>источники</Title>
        <Spacer size={4} />
      </Col>

      <Spacer size={8} />

      <Block>
        <>[a] аудио- и видеоматериалы, фильмы, передачи</>
        <Text>
          [a—a] alexander knaifel – composer&apos;s portrait (александр кнайфель
          в программе «царская ложа»). гтрк «санкт-петербург», 2006.
          <Spacer size={4} />
          [a—b] стенограмма лекции г. ковалевского, специально для
          «платоновского фестиваля искусств», 2024.
          <Spacer size={4} />
          [a—c] телепрограмма «невский ковчег. теория невозможного. борис
          понизовский», 15 сентября 2024.
          <Spacer size={4} />
          [a—e] «острова: семен аранович». реж. а. шпагин, 2014.
          <Spacer size={4} />
          [a—f] alexander knaifel – a composer. directed by jorge rubiera, 2012.
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>[b] интервью и монологи александра кнайфеля, статьи о нем</>
        <Text>
          [b—a] «услышать тишину», иосиф райскин // музыкальное обозрение. 2024.
          №7 (529)
          <Spacer size={4} />
          [b—b] «о работе в кино и роли случая…» [беседа георгия ковалевского с
          александром кнайфелем] // сортавала, август 2016
          <Spacer size={4} />
          [b—c] интервью композитора а. кнайфеля музыковеду с. савенко. 2023
          <Spacer size={4} />
          [b—d] «соло для динозавра: байки александра кнайфеля по просьбе олега
          сердобольского» // санкт-петербургские ведомости. 2000. 14 октября
          <Spacer size={4} />
          [b—e] «мост в эдем» [беседа с георгием ковалевским] // играем с начала
          / da capo al fine. 2013. №5(110)
          <Spacer size={4} />
          [b—f] «человек по своей природе – авангарден» [беседа со светланой
          поляковой] // культура. 2005. №39
          <Spacer size={4} />
          [b—g] «образ обратного» [беседа с алексеем поповым] // аудио-магазин.
          2013. №2 (109)
          <Spacer size={4} />
          [b—h] «берегись – встреча идет» [беседа с михаилом шатиным] //
          аудитория. газета рггу. 2007. № 35-36
          <Spacer size={4} />
          [b—i] «произнести музыку» [беседа с борисом филановским] //
          аудио-магазин. №5. 1999
          <Spacer size={4} />
          [b—j] «репетиция чуда, или свидетельство» [беседа с борисом
          филановским] // буклет к премьере оперы «алиса в стране чудес» в de
          netherlandse opera. амстердам. 2001 (август). на русском – в издании:
          музыкальная академия. 2002. №2
          <Spacer size={4} />
          [b—k] «и правда, как звезда в ночи, открылась…» // советская музыка.
          №11. 1975
          <Spacer size={4} />
          [b—l] «красота – момент горения. александр кнайфель» // музыкальное
          обозрение. 2014. №4(366)
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>[c] интервью, записанные для книги</>
        <Text>
          [c—a] композитор а. кнайфель
          <Spacer size={4} />
          [c—b] певица, жена а. кнайфеля т. мелентьева
          <Spacer size={4} />
          [c—c] музыковед г. ковалевский
          <Spacer size={4} />
          [c—d] дирижер а. штейнлухт
          <Spacer size={4} />
          [c—e] киновед л. аркус
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>[d] книги</>
        <Text>
          [d—a] соколов в. щеглов на «ленфильме». картина «я – актриса» /
          соколов в. // распятый шут. спб.: 2003
          <Spacer size={4} />
          [d—b] шпагин а. новейшая история отечественного кино. 1986-2000. кино
          и контекст. т. III. спб.: «сеанс», 2001
          <Spacer size={4} />
          [d—c] уилсон э. мстислав ростропович. композитор, учитель, легенда.
          москва: эксмо, 2011
          <Spacer size={4} />
          [d—d] долин. а. герман. интервью, эссе, сценарии. москва: новое
          литературное обозрение, 2011
          <Spacer size={4} />
          [d—e] пробуждение // аранович: сборник воспоминаний о кинорежиссере.
          спб.: студия «панорама», 1998
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>[e] статьи, рецензии и другие источники</>
        <Text>
          [e—a] павлова и. семен аранович. часть 2 «одиночество летчика в
          полете» // chapaev.media.
          <Spacer size={4} />
          [e—b] соколов в. «это было недавно, это было давно» [записала е.
          петрова] // кадр. 1991. №6
          <Spacer size={4} />
          [e—c] багров п. «друзья и годы» // каталог фестиваля архивного кино
          «белые столбы». м.: гфф. 2016
          <Spacer size={4} />
          [e—e] шпагин а. выпавший из гнезда // каталог фестиваля архивного кино
          «белые столбы». м.: гфф. 2016
          <Spacer size={4} />
          [e—f] «репетиция рая: к 75-летию мстислава ростроповича» // мариинский
          театр. 2002. №1-2
          <Spacer size={4} />
          [e—g] «борис понизовский: портрет на фоне города» // журнал «театр».
          2016
          <Spacer size={4} />
          [e—h] филиппенко а. «моя роль небольшая, но…» // chapaev.media.
          <Spacer size={4} />
          [e—i] дневник александра кнайфеля из личного архива композитора
          <Spacer size={4} />
          [e—j] письмо георгия кропачева александру кнайфелю, из личного архива
          александра кнайфеля
        </Text>
      </Block>
    </SidesKnaifel>

    <Spacer size={80} />

    <Footer />
  </Root>
);

export default Source;
